var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"common_button_switch",class:{ 'active': _vm.switchState },on:{"click":_vm.switchHandle}})}
var staticRenderFns = []

export { render, staticRenderFns }